export enum AssetExplorationViews {
  THREED = '3D',
  TRENDS = 'trends',
  DOCUMENTS = 'documents',
  PROPERTIES = 'properties',
  MEDIA = 'media',
  ACTIVITIES = 'activities',
  NOTIFICATIONS = 'notifications',
}
